<template>
  <div class="col-12">
    <div class="card card-body">
        <div class="col-12 table-responsive">
            <table class="table table-hover table-bordered">
                <thead>
                    <th>
                        المعلم
                    </th>
                    <th>
                        آخر تعديل
                    </th>
                    <th>
                        عرض
                    </th>
                </thead>
                <tbody>
                    <tr v-for="file in files" :key="file._id">
                        <td>
                            {{ file.teacher_name }}
                        </td>
                        <td>
                            {{ file.last_update }}
                        </td>
                        <td>
                            <button class="btn btn-primary btn-sm" v-b-modal.view @click="current = file">
                                <i class="fa fa-eye"></i>
                                عرض
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <b-modal id="view" :title="current.teacher_name" hide-footer size="lg">
        <div class="col-12 text-center g">
            <button class="btn btn-success" @click="save()">
                <i class="fa fa-save"></i>
                حفظ التقييمات
            </button>&nbsp;
            <a target="_blank" :href="`https://enjazfile.tahdir.net/pdfs/${current.type}.pdf`" class="btn btn-info" style="background: #0BA6DF !important; border: #6D94C5" >
                <i class="fa fa-file-pdf-o"></i>
                تحميل الدليل
            </a>
        </div>
        <template v-if="current.teacher_name">
            <app-collapse>
                <app-collapse-item v-for="item in current.items" :key="item.id" class="itemm" :title="(item.admin_percent >0 ? '🟢' : '🟡') + ' ' + item.title + ' ('+bbv(item)+')'">
                    <div class="g">
                        تقييمك: 
                        <input type="number" style="border: 1px solid #999; height: 30px; width: 40px; text-align: center" @change="checkpercent(item)" @keyup="checkpercent(item)" placeholder="0" v-model="item.admin_percent"> / {{item.percent}}
                    <br>
                        تغدية راجعة: <br><textarea type="text" style="border: 1px solid #999; width: 200px; padding-right: 3px" rows="3" placeholder="اكتب هنا..." v-model="item.admin_notes"></textarea>
             
                    </div>
                    <template v-for="task in item.tasks">
                        <div class="g" v-if="task.status == 1 && task.selected" :key="task.title">
                            <div class="border g" style="background: #fafafa; border-radius: 5px">
                                <h5># {{ task.title }}</h5>
                                <br>
                                <h5>التفاصيل: {{task.content}}</h5>
                                <div v-if="task.files.length" class="row">
                                    <div v-for="img in task.files" :key="img" class="col-6 col-lg-3 g">
                                        <a :href="img" target="_blank">
                                            <img :src="img" style="width: 100%; border: 1px solid #333; border-radius: 5px" alt="">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </app-collapse-item>
            </app-collapse>
        </template>
    </b-modal>
  </div>
</template>

<script>
import {  VBModal, BModal, BDropdown, BDropdownItem } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
export default {
  components: {
    BDropdown,
    BDropdownItem,
    AppCollapse,
    AppCollapseItem,
    BModal
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  data() {
    return {
        files: [],
        current: {},
        user: JSON.parse(localStorage.getItem('user')),
    };
  },
  created(){
    var g = this;
    $.post("https://server-enjazfile.tahdir.net/admin/list", {
        user_id: g.user._id
    }).then(function(r){
        g.files = r.response
    })
  },
  methods: {
    bbv(item){
        var t = (item.tasks.filter(function(x){return (x.selected && x.status == 1) ? x : false}))
        return t.length
    },
    save(){
        var g = this;
        var rates = [];
        g.current.items.forEach(function(a){
            rates.push({
                id: a.id,
                percent: a.admin_percent,
                    notes: a.admin_notes
            })
        })
        $.post("https://server-enjazfile.tahdir.net/admin/add-rate", {
            user_id: g.user._id,
            id: g.current._id,
            rates: rates
        }).then(function(r){
            alert("تم الحفظ بنجاح", 100)
        })
    },
    checkpercent(item){
        if(item.admin_percent > item.percent){
            item.admin_percent = item.percent
        }
        if(item.admin_percent.toString().includes(".")){
            item.admin_percent = item.admin_percent.toString().split(".")[0]
        }
    }
  }
}
</script>

<style>

</style>